import React, { useEffect, useState } from "react";
import { MdArrowDownward } from "react-icons/md";
import ThemeAddButton from "../components/ThemeComponent/ThemeAddButton";
import { ThemeButton } from "../components/ThemeComponent/ThemeButtons";
import Table from "../components/ThemeComponent/ThemeDataTable";
import ThemePagination from "../components/ThemeComponent/ThemePagination";
import ThemeSearchInput from "../components/ThemeComponent/ThemeSearchInput";
import ThemeSpinner from "../components/ThemeComponent/ThemeSpinner";
import { PageHeading } from "../components/ThemeComponent/ThemeText";
import { success } from "../utils/helpers.js";
import AddBilling from "../components/modals/AddBilling";
import ThemeModal from "../components/ThemeComponent/ThemeModal";
import {
  useDeletebillingMutation,
  useGetbillingsQuery,
  useGetExportBillsCSVQuery,
} from "../Redux/services/ClientAPis/billingApi";
import RemoveModal from "../components/modals/RemoveModal";
import { useGetExportCSVQuery } from "../Redux/services/ClientAPis/patientApi";
const BillingManagement = () => {
  const [loading, setLoading] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [addOpen, setAddOpen] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [removeOpen, setRemoveOpen] = useState(false);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState('');
  const [totalPages, setTotalPages] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [modalData, setModalData] = useState(null);

  const { data, isSuccess, isLoading, isFetching, refetch } =
    useGetbillingsQuery(
      {
        search: searchQuery.length >= 3 ? searchQuery : "",
        limit: pageSize,
        page: page,
      },
      { refetchOnMountOrArgChange: true }
    );
  const [deletebilling, { isLoading: deleteLoading }] =
    useDeletebillingMutation();

    const {
      data: csv,
      isLoading: exporting,
      refetch: refetchCSV,
    } = useGetExportBillsCSVQuery();

  useEffect(() => {
    if (data) {
      // console.log(data);
      setPageSize(data.links.per_page);
      setPage(data.links.current);
      setTotalRecords(data.links.total_records === 0 ? '' : data.links.total_records);
      setTotalPages(data.links.total);
      // setRowData(data.data);
    }
  }, [data]);

  const onRemoveClick = async () => {
    await deletebilling({ id: modalData.id });
    setTimeout(() => {
      setRemoveOpen(false);
      success("Successfully Removed");
      refetch();
    }, 500);
  };

  const header = [
    {
      title: "Patient Name",
      dataIndex: "name",
      style: { textAlign: "left" },
      elementStyle: { textAlign: "left", width: "180px", minWidth: "200px" },
      render: (_, rowData) => {
        return <div>{rowData?.patient?.name}</div>;
      },
    },
    {
      title: "Email",
      dataIndex: "email",
      style: { textAlign: "left" },
      elementStyle: { textAlign: "left", width: "180px", minWidth: "200px" },
      render: (_, rowData) => {
        return <div>{rowData?.patient?.email}</div>;
      },
    },
    {
      title: "Phone",
      dataIndex: "phone",
      style: { textAlign: "left" },
      elementStyle: { textAlign: "left", width: "180px", minWidth: "200px" },
      render: (_, rowData) => {
        return <div>{rowData?.patient?.mobile_no}</div>;
      },
    },
    {
      title: "Bill Amount",
      dataIndex: "amount",
      style: { textAlign: "left" },
      elementStyle: { textAlign: "left", width: "180px", minWidth: "200px" },
    },
    {
      title: "Patient Documents",
      dataIndex: "patientdocuments",
      style: { textAlign: "left" },
      elementStyle: { textAlign: "left", width: "180px", minWidth: "200px" },
      render: (_, rowData, index) => (
        <div className="d-flex flex-row align-items-center gap-2 justify-content-center">
          <img
            src={
              rowData?.patient?.attachments?.length > 0 &&
              (["png", "jpeg", "jpg"].includes(
                rowData?.patient?.attachments[0]?.media_type
              )
                ? rowData?.patient?.attachments[0]?.media_url
                : "/images/pdf.png")
            }
            style={{ maxheight: "28px", width: "28px", height: "auto" }}
          />
        </div>
      ),
    },
  ];

  // const data = [
  //   {
  //     slug: 1,
  //     client_name: "Cameron Williamson",
  //     phone: "(603) 555-0123",
  //     email: "nathan.roberts@example.com",
  //     designation: "Physician",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //     billamount: "$1255",
  //   },
  //   {
  //     slug: 2,
  //     client_name: "Floyd Miles",
  //     phone: "(209) 555-0104",
  //     email: "debbie.baker@example.com",
  //     designation: "Surgeon",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //     billamount: "$3255",
  //   },
  //   {
  //     slug: 3,
  //     client_name: "Annette Black",
  //     phone: "(704) 555-0127",
  //     email: "debbie.lawson@example.com",
  //     designation: "Radiologist",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //     billamount: "$1655",
  //   },
  //   {
  //     slug: 4,
  //     client_name: "Theresa Webb",
  //     phone: "(808) 555-0111",
  //     email: "novah.simmons@example.com",
  //     designation: "Neurologist",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //     billamount: "$5255",
  //   },
  //   {
  //     slug: 5,
  //     client_name: "Kathryn Murphy",
  //     phone: "(307) 555-0133",
  //     email: "jessica.hanson@example.com",
  //     designation: "Physiotherapist",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //     billamount: "$85",
  //   },
  //   {
  //     slug: 6,
  //     client_name: "Brooklyn Simmons",
  //     phone: "(702) 555-0122",
  //     email: "felicia.reid@example.com",
  //     designation: "Pediatrician",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //     billamount: "$655",
  //   },
  //   {
  //     slug: 7,
  //     client_name: "Robert Fox",
  //     phone: "(252) 555-0125",
  //     email: "tim.jennings@example.com",
  //     designation: "Gynecologist",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //     billamount: "$15",
  //   },
  //   {
  //     slug: 8,
  //     client_name: "Dianne Russell",
  //     phone: "(201) 555-0124",
  //     email: "curtis.weaver@example.com",
  //     designation: "Anesthesiologist",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //     billamount: "$1255",
  //   },
  //   {
  //     slug: 9,
  //     client_name: "Leslie Alexander",
  //     phone: "(319) 555-0115",
  //     email: "michelle.rivera@example.com",
  //     designation: "Pathologist",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //     billamount: "$1255",
  //   },
  //   {
  //     slug: 10,
  //     client_name: "Devon Lane",
  //     phone: "(207) 555-0119",
  //     email: "dolores.chambers@example.com",
  //     designation: "Oncologist",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //     billamount: "$1255",
  //   },
  // ];
  const handleDownloadCLick = async () => {
    try {
      setDownloadLoading(true);
      refetchCSV();
      if (csv) {
        const a = document.createElement("a");
        a.href = csv?.data?.file_url;
        a.download = "patients.csv";
        document.body.appendChild(a);
        a.click();
        a.remove();
        success("Download Successfully");
        setDownloadLoading(false);
      }
    } catch (error) {
      console.log(error);
      setDownloadLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    setTimeout(() => setLoading(false), 1500);
  }, [page]);

  return (
    <div className="dashboard-page patient-page">
      <div className="header d-flex justify-content-between">
        <PageHeading text={"Bill Management"} count={totalRecords} />
        <div className="d-flex responsive-flex align-items-center gap-3">
          <ThemeAddButton
            text={"Add Bill"}
            onClick={() => setAddOpen(true)}
            className={"responsive-margin"}
          />
          <ThemeSearchInput setSearchQuery={setSearchQuery} />
          <ThemeButton
            className={"download-btn responsive-margin"}
            onClick={handleDownloadCLick}
            text={
              downloadLoading ? (
                <ThemeSpinner />
              ) : (
                <div className="d-flex gap-2">
                  Download CSV <MdArrowDownward size={20} />
                </div>
              )
            }
          />
        </div>
      </div>
      <div className="table-content mt-2">
        <Table
          header={header}
          data={data?.data}
          loading={isLoading}
          removeText="Task"
          onEditClick={() => setShowEdit(true)}
          setModalData={setModalData}
          setRemoveOpen={() => setRemoveOpen(true)}
        />
      </div>
      <div className="pagination mt-3">
        {/* {!loading && ( */}
          <ThemePagination
            activePage={page}
            totalPages={totalPages}
            setPage={setPage}
            page={page}
          />
        {/* )} */}
      </div>
      {addOpen && (
        <ThemeModal
          size={"md"}
          modalContent={<AddBilling setIsOpen={setAddOpen} refetch={refetch} />}
          title={"Add Billing"}
          className={"edit-profile"}
          isOpen={addOpen}
          setIsOpen={setAddOpen}
        />
      )}
      {showEdit && (
        <ThemeModal
          size={"md"}
          modalContent={
            <AddBilling
              setIsOpen={setShowEdit}
              modalData={modalData}
              refetch={refetch}
            />
          }
          title={"Update Billing"}
          className={"edit-profile"}
          isOpen={showEdit}
          setIsOpen={setShowEdit}
        />
      )}
      {removeOpen && (
        <ThemeModal
          size={"sm"}
          modalContent={
            <RemoveModal
              setIsOpen={setRemoveOpen}
              modalData={modalData}
              refetch={refetch}
              onRemoveClick={onRemoveClick}
              isLoading={deleteLoading}
            />
          }
          title={""}
          className={"edit-profile"}
          isOpen={removeOpen}
          setIsOpen={setRemoveOpen}
        />
      )}
    </div>
  );
};

export default BillingManagement;
